module.exports = __webpack_public_path__ + "static/img/sofa.8685f4af.png";